import { Link, Navigate, useParams } from 'react-router-dom';
import { Icon } from '../components/Icon';
import { ErrorState, Loading } from '../components/StateBlock';
import { useAsync } from '../hooks/useAsync';
import { getChallenge } from '../api';
import { fmtClock, fmtDuration } from '../utils/format';
import { paths } from '../paths';

/** Final result. All numbers come from the server. */
export function ResultPage() {
  const { eventId = '' } = useParams();
  const {
    data: challenge,
    loading,
    error,
    reload,
  } = useAsync(() => getChallenge(eventId), [eventId]);

  if (loading && !challenge) return <Loading />;
  if (error || !challenge) return <ErrorState onRetry={reload} />;

  const { attendance: a, rules } = challenge;
  if (a?.status !== 'COMPLETED')
    return <Navigate to={paths.detail(eventId)} replace />;

  const points = a.pointsEarned ?? 0;
  const full = points >= rules.maxPoints;
  const pct = rules.maxPoints
    ? Math.round((points / rules.maxPoints) * 100)
    : 100;

  return (
    <div className="pv-result">
      <div className="pv-result__hero">
        <div className="pv-result__check">
          <Icon name="check" size={36} />
        </div>
        <h1 className="pv-h2">
          {full ? 'Presença completa!' : 'Presença registrada!'}
        </h1>
        <p>
          {full
            ? 'Você cumpriu o tempo mínimo e ganhou todos os pontos.'
            : `Você ficou ${fmtDuration(a.stayMinutes)} dos ${fmtDuration(rules.minStayMinutes)} mínimos, então recebeu pontos proporcionais ao tempo.`}
        </p>
      </div>

      <div className="pv-container pv-result__body pv-stack">
        <section className="pv-card pv-center pv-stack pv-stack--sm">
          <span className="pv-muted pv-small">Você ganhou</span>
          <div className="pv-result__points">
            <strong>+{points}</strong> de {rules.maxPoints} pontos
          </div>
          <div className="pv-progress" aria-hidden="true">
            <div style={{ width: `${pct}%` }} />
          </div>
          {!full && rules.minStayMinutes ? (
            <p className="pv-muted pv-small">
              Com {fmtDuration(rules.minStayMinutes)} ou mais de permanência
              você ganha os {rules.maxPoints} pontos.
            </p>
          ) : null}
        </section>

        <section className="pv-card pv-summary">
          <div>
            <span className="pv-muted">Entrada</span>
            <strong>{fmtClock(a.checkInAt)}</strong>
          </div>
          <div>
            <span className="pv-muted">Saída</span>
            <strong>{fmtClock(a.checkOutAt)}</strong>
          </div>
          <div>
            <span className="pv-muted">Tempo no local</span>
            <strong>{fmtDuration(a.stayMinutes)}</strong>
          </div>
        </section>

        <div className="pv-stack pv-stack--sm">
          <Link
            to={paths.list()}
            className="pv-btn pv-btn--primary pv-btn--block"
          >
            Voltar aos desafios
          </Link>
        </div>
      </div>
    </div>
  );
}
